const CHECKOUT_DRAFT_KEY = "odk.checkout.draft.v1";
const PENDING_PAYMENT_KEY = "odk.checkout.pending-payment.v1";
const DRAFT_TTL_MS = 4 * 60 * 60 * 1000;

function readJson(key) {
  try {
    const value = sessionStorage.getItem(key);
    return value ? JSON.parse(value) : null;
  } catch {
    sessionStorage.removeItem(key);
    return null;
  }
}

export function loadCheckoutDraft(userId) {
  const draft = readJson(CHECKOUT_DRAFT_KEY);
  if (!draft) return null;

  const expired = !draft.savedAt || Date.now() - draft.savedAt > DRAFT_TTL_MS;
  const wrongUser = String(draft.userId) !== String(userId);
  if (expired || wrongUser) {
    sessionStorage.removeItem(CHECKOUT_DRAFT_KEY);
    return null;
  }

  return draft.state ?? null;
}

export function saveCheckoutDraft(state, userId) {
  sessionStorage.setItem(CHECKOUT_DRAFT_KEY, JSON.stringify({
    state,
    userId,
    savedAt: Date.now(),
  }));
}

export function savePendingPayment(payment) {
  sessionStorage.setItem(PENDING_PAYMENT_KEY, JSON.stringify({
    ...payment,
    savedAt: Date.now(),
  }));
}

export function loadPendingPayment(userId) {
  const payment = readJson(PENDING_PAYMENT_KEY);
  if (!payment) return null;

  const expired = !payment.savedAt || Date.now() - payment.savedAt > DRAFT_TTL_MS;
  const wrongUser = String(payment.userId) !== String(userId);
  if (expired || wrongUser) {
    sessionStorage.removeItem(PENDING_PAYMENT_KEY);
    return null;
  }

  return payment;
}

export function clearPendingPayment() {
  sessionStorage.removeItem(PENDING_PAYMENT_KEY);
}

export function clearCheckoutRecovery() {
  sessionStorage.removeItem(CHECKOUT_DRAFT_KEY);
  sessionStorage.removeItem(PENDING_PAYMENT_KEY);
}
